import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";
import fontpage from "../../images/fontpage.jpg";
import logocdac from "../../images/cdac-alt.jpg";
import title from "../../images/Diginyay-transparent.png";
import logo from "../../images/main-logo.png";
import front from "../../images/FRONTPAGES/CDAC FRONT NEWS.png";
import ABPNews from "../../images/abp.png";
import IndianExpress from "../../images/INDIAN EXPRESS.jpg";
import NewsMinute from "../../images/newsminute.png";
import MuslimMirror from "../../images/MUSLIM MIRROR.png";
import TheHindu from "../../images/THEHINDU.jpg";
import Scroll from "../../images/SCROLL.png";
import NewsLaundry from "../../images/CHIMTI.png";
import TheWire from "../../images/WIRE.png";
import DeccanHerald from "../../images/DECCAN HERALD.png";
import TheGuardian from "../../images/GUARDIAN.png";
import ThePrint from "../../images/THEPRINT.png";
import AlJazeera from "../../images/JAZEERA.png";
import NavaBharatTimes from "../../images/NBT.png";
import deccan from "../../images/pngegg.png";
import ndtv from "../../images/NDTV.png";
import indiatoday from "../../images/IndiaToday.png";
import RisingKashmir from "../../images/RisingKashmir.png";
import hindustantimes from "../../images/hindustan times.png";
import fpj from "../../images/free press journal.png";
import punjab from "../../images/punjab kesari.png";
import bhaskar from "../../images/BHASKAR.png";
import toi from "../../images/TOI.png";
import outlook from "../../images/outlook.jpg";
// Map channel names to their corresponding logos

const channelLogos = {
  "Deccan Chronicles": deccan,
  "The Guardian": TheGuardian,
  "Deccan Herald": DeccanHerald,
  "The Wire": TheWire,
  "The Print": ThePrint,
  Scroll: Scroll,
  "News Minute": NewsMinute,
  "The Hindu": TheHindu,
  "Rising Kashmir": null,
  "News Laundry": NewsLaundry,
  "Nava Bharat Times": NavaBharatTimes,
  "Indian Express": IndianExpress,
  "Muslim Mirror": MuslimMirror,
  "ABP News": ABPNews,
  "Al Jazeera": AlJazeera,
  NDTV: ndtv,
  "India Today": indiatoday,
  "Rising Kashmir": RisingKashmir,
  "Punjab Kesari": punjab,
  "Free Press Journal": fpj,
  "Dainik Bhashkar": bhaskar,
  "Times Of India": toi,
  Outlook: outlook,
  "Hindustan Times": hindustantimes,
};

export const PrintReportNews = async (
  serverresponse,
  analyticsData,
  pieChartRef,
  sectionPieChartRef,
  sentimentPieChartRef,
  selectedPlatforms,
  barChartRef,
  wordCloudRef,
  setIsCompleted,
  setIsLoading,
  pdfToSimple,
  pdfFromSimple,
  NewsCount
) => {
  setIsLoading(true); // Show loading indicator
  //  
  //  
 

  try {
    const pdf = new jsPDF("p", "mm", "a4");

    // Add background image to the first page
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(front, "JPEG", 0, 0, imgWidth, imgHeight);

    // Add the title image in the top middle of the page
    const titleImgWidth = 100; // Set your title image width
    const titleImgHeight = 30; // Set your title image height
    const pageWidth = pdf.internal.pageSize.getWidth();
    const titleImgX = (pageWidth - titleImgWidth) / 2;
    const titleImgY = 50; // Set the desired Y position of the title image

    // Set the text color and font size
    pdf.setTextColor(255, 255, 255);

    pdf.setFontSize(26);

    if (pdfToSimple) {
      pdf.setFont(undefined, "bold");
      pdf.text(`  ${pdfToSimple}`, 41, 213);
    }

    pdf.addPage();

    pdf.addImage(fontpage, "JPEG", 0, 0, imgWidth, imgHeight);

    const cardWidth = 60; // Card width
    const cardHeight = 30; // Card height
    const imageWidth = 15; // Logo width
    const imageHeight = 15; // Logo height
    const horizontalSpacing = 4; // Space between cards horizontally
    const verticalSpacing = 6; // Space between rows vertically

    // Calculate total number of cards per row based on page width
    const cardsPerRow = Math.floor(
      (pdf.internal.pageSize.getWidth() - horizontalSpacing) /
        (cardWidth + horizontalSpacing)
    );

    // Calculate total number of rows needed
    const totalRows = Math.ceil(Object.keys(NewsCount).length / cardsPerRow);

    // Calculate total width and height of the content
    const totalContentWidth =
      cardsPerRow * (cardWidth + horizontalSpacing) - horizontalSpacing;
    const totalContentHeight =
      totalRows * (cardHeight + verticalSpacing) - verticalSpacing;

    // Calculate offsets for centering
    const xOffsetInitial =
      (pdf.internal.pageSize.getWidth() - totalContentWidth) / 2;
    const yOffsetInitial =
      (pdf.internal.pageSize.getHeight() - totalContentHeight) / 2;

    // Calculate total number of channels and total count
    const totalChannels = Object.keys(NewsCount).length;
    const totalCount = Object.values(NewsCount).reduce(
      (sum, count) => sum + count,
      0
    );

    // Add header with total counts
    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 0); // Set text color to black
    pdf.text(`Total News Channels: ${totalChannels}`, 120, 25); // Header for total number of channels
    pdf.text(`Total Count: ${totalCount}`, 120, 30); // Header for total count

    // Positioning for the card layout
    let xOffset = xOffsetInitial;
    let yOffset = yOffsetInitial + 15;

    Object.entries(NewsCount)
      .sort(([, countA], [, countB]) => countB - countA)

      .forEach(([channel, count], index) => {
        pdf.setTextColor(0, 0, 0); // Set text color to black

        // Draw the rectangle (card)
        pdf.rect(xOffset, yOffset, cardWidth, cardHeight);

        // Add the logo if available
        const logo = channelLogos[channel];
        if (logo) {
          pdf.addImage(
            logo,
            "JPEG",
            xOffset + 2,
            yOffset + 3,
            imageWidth,
            imageHeight
          );
        }

        // Add the channel name
        pdf.setFontSize(12);
        pdf.text(`${channel}`, xOffset + imageWidth + 5, yOffset + 10);

        // Add the count
        pdf.setFontSize(12);
        pdf.text(`Count: ${count}`, xOffset + imageWidth + 5, yOffset + 15);

        // Move to the next card position
        xOffset += cardWidth + horizontalSpacing;

        // Move to the next row if end of the current row is reached
        if ((index + 1) % cardsPerRow === 0) {
          xOffset = xOffsetInitial; // Reset X offset to start of the row
          yOffset += cardHeight + verticalSpacing; // Move to the next row
        }
      });

    // Start table from the next page
    pdf.addPage();

    const tableData = serverresponse || analyticsData;

    if (!tableData || tableData.length === 0) {
      console.error("No data available to print");
      return;
    }

    const tableColumnHeaders = [
      "S.No",
      "Date",
      "News Channel",
      "Title",
      "Author",
      "Sentiment Accuracy",
    ];

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const tableRows = tableData.map((data, index) => {
      //  

      const truncateContent = (content, wordLimit) => {
        if (typeof content !== "string") {
          return "N/A"; // Or handle it in another way, e.g., return an empty string
        }
        const words = content.split(" ");
        if (words.length > wordLimit) {
          return words.slice(0, wordLimit).join(" ") + "...";
        }
        return content;
      };

      return [
        String(index + 1),
        data.datePublished ? formatDate(data.datePublished) : "N/A",
        String(data.newsChannel || "N/A"),
        {
          // content: truncateContent(data.title, 10),
          content: data.title,
          link: data.link,
        },
        String(data.author || "N/A"),
        String(
          data.sentimentAccuracy
            ? `Positive: ${
                data.sentimentAccuracy.positive || "N/A"
              }%\nNegative: ${data.sentimentAccuracy.negative || "N/A"}%`
            : "N/A"
        ),
      ];
    });

    // Log the prepared table rows to ensure all data is in the correct format
    //  

    pdf.autoTable({
      head: [tableColumnHeaders],
      body: tableRows,
      startY: 10,
      tableWidth: "auto",
      styles: {
        cellPadding: 2,
        fontSize: 10,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [0, 0, 0],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      bodyStyles: {
        textColor: [0, 0, 0],
      },
      alternateRowStyles: {
        fillColor: [227, 242, 253],
      },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 22 },
        2: { cellWidth: 27 },
        3: { cellWidth: 75 },
        4: { cellWidth: 40 },
        5: { cellWidth: 32 }, // Adjust width for the sentiment accuracy column
      },
      margin: { top: 1, left: 1, right: 1, bottom: 1 },
      didParseCell: function (data) {
        if (data.column.index === 6 && data.cell.section === "body") {
          data.cell.styles.cellPadding = 2;
        }
      },
      didDrawCell: function (data) {
        if (data.cell.section === "body" && data.cell.raw) {
          const cell = data.cell;
          const pdfDoc = data.doc;
          const cellWidth =
            cell.width - cell.padding("left") - cell.padding("right");
          const textPos = {
            x: cell.x + cell.padding("left"),
            y: cell.y + cell.padding("top") + 2,
          };

          if (data.column.index === 3 && cell.raw.link) {
            pdfDoc.setFontSize(10);
            pdfDoc.setTextColor(0, 0, 255); // Set the text color to blue to indicate a link
            const splitText = pdfDoc.splitTextToSize(
              cell.raw.content,
              cellWidth
            );
            const lineSpacing = 4;
            splitText.forEach((line, index) => {
              pdfDoc.textWithLink(
                line,
                textPos.x,
                textPos.y + index * lineSpacing,
                { url: cell.raw.link }
              );
            });
          }
        }
      },
      willDrawCell: function (data) {
        if (
          data.column.index === 3 &&
          data.cell.section === "body" &&
          data.cell.raw
        ) {
          const cell = data.cell;
          cell.text = "";
        }
      },
      rowPageBreak: "avoid",
    });

    const platformLabels =
      selectedPlatforms.length === 0
        ? "Consolidated"
        : selectedPlatforms[0].label;
    if (pdfToSimple) {
      pdf.save(`CSMART_${platformLabels}_News_Report_${pdfToSimple}.pdf`);
      setIsCompleted(true);
    } else {
      pdf.save(`CSMART_${platformLabels}_Report.pdf`);
      setIsCompleted(true);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
  setIsLoading(false);
};
